// HelpAndSupport.tsx
import React from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/sections/accountSection/HelpAndSupport";

const HelpAndSupport: React.FC = () => {
  const supportResources = [
    {
      icon: "📚",
      title: "Documentação",
      description: "Acesse nossa documentação completa",
      action: "Abrir Docs",
      link: "#",
    },
    {
      icon: "🎓",
      title: "Tutoriais",
      description: "Aprenda com nossos guias passo a passo",
      action: "Ver Tutoriais",
      link: "#",
    },
    {
      icon: "❓",
      title: "FAQ",
      description: "Perguntas frequentes respondidas",
      action: "Ver FAQ",
      link: "#",
    },
    {
      icon: "💬",
      title: "Suporte Online",
      description: "Chat em tempo real com nossa equipe",
      action: "Iniciar Chat",
      link: "#",
    },
  ];

  const contactMethods = [
    {
      icon: "📧",
      title: "Email",
      description: "suporte@alfredo.com",
      action: "Enviar Email",
      link: "mailto:suporte@alfredo.com",
    },
    {
      icon: "📞",
      title: "Telefone",
      description: "(11) 4002-8922",
      action: "Ligar",
      link: "tel:+551140028922",
    },
    {
      icon: "🕒",
      title: "Horário de Atendimento",
      description: "Segunda a Sexta, 9h às 18h",
      action: "",
    },
  ];

  const handleActionClick = (link: string, action: string) => {
    if (link && link !== "#") {
      if (action === "Enviar Email" || action === "Ligar") {
        window.open(link, "_blank");
      } else {
        // Aqui você pode adicionar lógica para outras ações
        console.log(`${action} clicado`);
      }
    }
  };

  return (
    <AlfredoStyles.FieldsContainer>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(calc(var(--u) * 280), 1fr))",
          gap: "var(--sp-20)",
          marginBottom: "var(--sp-32)",
        }}
      >
        {supportResources.map((resource, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #e1e5e9",
              borderRadius: "12px",
              padding: "var(--sp-24)",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "var(--sp-16)",
              transition: "all 0.3s ease",
              cursor: "pointer",
              backgroundColor: "white",
            }}
            onClick={() => handleActionClick(resource.link, resource.action)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div style={{ fontSize: "var(--fs-6xl)" }}>{resource.icon}</div>
            <div style={{ fontWeight: 600, fontSize: "var(--fs-lg)" }}>
              {resource.title}
            </div>
            <div
              style={{
                color: "#6c757d",
                fontSize: "var(--fs-md)",
                flex: 1,
                lineHeight: "1.5",
              }}
            >
              {resource.description}
            </div>
            <AlfredoStyles.SecondaryButton
              style={{
                width: "100%",
                transition: "all 0.2s ease",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleActionClick(resource.link, resource.action);
              }}
            >
              {resource.action}
            </AlfredoStyles.SecondaryButton>
          </div>
        ))}
      </div>

      {/* Contato */}
      <AlfredoStyles.SectionTitle
        style={{ fontSize: "var(--fs-xl)", marginTop: "var(--sp-32)", marginBottom: "var(--sp-20)" }}
      >
        Entre em Contato
      </AlfredoStyles.SectionTitle>

      <div style={{ display: "grid", gap: "var(--sp-16)", marginBottom: "var(--sp-32)" }}>
        {contactMethods.map((contact, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "var(--sp-20)",
              border: "1px solid #e1e5e9",
              borderRadius: "12px",
              gap: "var(--sp-20)",
              flexWrap: "wrap",
              backgroundColor: "white",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div style={{ fontSize: "var(--fs-4xl)", flexShrink: 0 }}>
              {contact.icon}
            </div>
            <div style={{ flex: 1, minWidth: "calc(var(--u) * 200)" }}>
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: "var(--sp-8)",
                  fontSize: "var(--fs-base)",
                }}
              >
                {contact.title}
              </div>
              <div style={{ color: "#6c757d", fontSize: "calc(var(--u) * 15)" }}>
                {contact.description}
              </div>
            </div>
            {contact.action && (
              <AlfredoStyles.Button
                style={{
                  padding: "var(--sp-10) var(--sp-20)",
                  fontSize: "var(--fs-md)",
                  minWidth: "calc(var(--u) * 120)",
                }}
                onClick={() =>
                  handleActionClick(contact.link || "#", contact.action)
                }
              >
                {contact.action}
              </AlfredoStyles.Button>
            )}
          </div>
        ))}
      </div>

      {/* Status do Sistema */}
      <AlfredoStyles.SectionTitle
        style={{ fontSize: "var(--fs-xl)", marginTop: "var(--sp-32)", marginBottom: "var(--sp-20)" }}
      >
        Status do Sistema
      </AlfredoStyles.SectionTitle>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "var(--sp-20)",
          backgroundColor: "#f0f9f0",
          border: "1px solid #d4edda",
          borderRadius: "12px",
          gap: "var(--sp-16)",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "var(--sp-16)",
            flex: 1,
          }}
        >
          <div
            style={{
              width: "calc(var(--u) * 12)",
              height: "calc(var(--u) * 12)",
              borderRadius: "50%",
              backgroundColor: "#28a745",
              flexShrink: 0,
              animation: "pulse 2s infinite",
            }}
          />
          <div>
            <div
              style={{ fontWeight: 600, fontSize: "var(--fs-base)", color: "#155724" }}
            >
              Todos os sistemas operando normalmente
            </div>
            <div style={{ color: "#6c757d", fontSize: "var(--fs-md)" }}>
              Última verificação: {new Date().toLocaleTimeString()}
            </div>
          </div>
        </div>
        <AlfredoStyles.SecondaryButton>
          Ver Status Completo
        </AlfredoStyles.SecondaryButton>
      </div>

      <style>{`
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </AlfredoStyles.FieldsContainer>
  );
};

export default HelpAndSupport;
